export type ValueOf<T> = T[keyof T];

export const SideMenuItems = Object.freeze({
  WELCOME: "welcome",
  USERS: "users",
  GESTORE: "gestore",
  MAP: "map",
  PODS: "pods",
  INSTALLATIONS: "installations",
  STATIONS: "stations",
  SESSIONS: "sessions",
  CHARGE_DETAIL_RECORD: "charge-detail-record",
  PAYMENTS: "payments",
  COST_REVENUE_SPLIT: "cost-revenue-split",
  INVOICE: "invoice",
  CONTRACTS: "contracts",
  TARIFFS: "tariffs",
  GROUPS: "groups",
  GATEWAYS: "gateways",
  CHATAI: "chat-ai",
  DOMAINS: "domains",
  COMPANY_ROLES: "companies-roles",
  SPONSORSHIP_POLICIES: "sponsorship-policies",
  /**
   * Strumenti di diagnosi e verifica, solo ADMIN. `getSideMenuVisibility` dà agli admin TUTTE le
   * voci di questo enum e agli altri ruoli una whitelist esplicita: esserci qui basta a renderle
   * admin-only. Le pagine esistevano già ma non erano in questo enum, quindi il merge col backend
   * le scartava e restavano raggiungibili solo digitando l'URL a mano.
   */
  SESSION_CLOSURES: "session-closures",
  SESSION_REPLAY: "session-replay",
  STATION_QUIRK_PROFILE: "station-quirk-profile",
  SETTINGS: "settings"
});

export type SideMenuItemsValues = ValueOf<typeof SideMenuItems>;
export type SideMenuItemsKeys = keyof typeof SideMenuItems;

export const SideMenuContentItems = Object.freeze({
  INFO_CONTENT: "info-content",
  INFO_CHAPTER: "info-chapter",
  INFO_SECTION: "info-section",
  INFO_MULTIMEDIA: "info-multimedia"
});

export type SideMenuContentItemsValues = ValueOf<typeof SideMenuContentItems>;
export type SideMenuContentItemsKeys = keyof typeof SideMenuContentItems;

export const SideMenuAboutItems = Object.freeze({
  ABOUT_LEGENDA: "about-legenda",
  ABOUT_VERSIONS: "about-versions"
});

export type SideMenuAboutItemsValues = ValueOf<typeof SideMenuAboutItems>;
export type SideMenuAboutItemsKeys = keyof typeof SideMenuAboutItems;

export declare const SideMenuReportsItems: Readonly<{
  REPORTS_QUERY: "reports-query";
  REPORTS_EXPORT: "reports-export";
}>;

export type SideMenuReportsItemsValues = ValueOf<typeof SideMenuReportsItems>;
export type SideMenuReportsItemsKeys = keyof typeof SideMenuReportsItems;
